import { useSelector } from "react-redux";
import { RootState } from "../store/reducers/types/root";
import { DefinedUseQueryResult, useQuery } from "@tanstack/react-query";
import { ApiPaths, DeviceApiPaths } from "../services/paths";
import React from "react";
import { ListDevicesRequest, ListDevicesResponse } from "../services/types";
import { AxiosResponse } from "axios";
import { apiListDevices } from "../services/device";

interface UseDevicesListProps {
  enabled?: boolean;
  defaultBody?: ListDevicesRequest;
}

export function useDevicesList({
  enabled = true,
  defaultBody = {
    pagination: {
      limit: 10,
      offset: 0,
    },
  },
}: UseDevicesListProps): [
  DefinedUseQueryResult<AxiosResponse<ListDevicesResponse, any> | null, Error>,
  React.Dispatch<React.SetStateAction<ListDevicesRequest>>
] {
  const token = useSelector((state: RootState) => state.user.token);
  const [body, setBody] = React.useState<ListDevicesRequest>(defaultBody);
  const data = useQuery({
    queryKey: [ApiPaths.USER, DeviceApiPaths.LIST_DEVICES, token, body],
    enabled: false,
    initialData: null,
    queryFn: () => apiListDevices(token as string, body),
  });

  React.useEffect(() => {
    if (enabled && token) {
      data.refetch();
    }
  }, [token, body]);

  return [data, setBody];
}
